const views = import.meta.glob('../../views/**/*.vue');

/**
 * @description 处理后端返回的 `component` 路径，拼装实现懒加载
 * @param {String} path
 * @returns {Object}
 */
export function loadView(path, prefix) {
    if (typeof path === 'string') {
        if (path.indexOf('layouts') !== -1) {
            return views[`../../views/${path}.vue`];
        }
        if (prefix) return views[`../../views/modules/${prefix}/${path}.vue`];
        return views[`../../views/modules/${path}.vue`];
    }
}

/**
 * @description 递归处理每一项 `component` 中的路径
 * @param {Object} view
 * @returns {Object}
 */
export function dynamicRouter(view, prefix) {
    if (view.component) view.component = loadView(view.component, prefix);
    if (view.children) view.children.map(item => dynamicRouter(item, prefix));
    return view;
}
